import { useTranslation } from 'react-i18next';
import { Button, Col, Row, Section, Title } from 'ui';
import { Separator, SocialButtons } from '../components';

type P = {
  onNavigateToCheckCode: ({ tokenToGetCode, tokenToLogin }: { tokenToGetCode?: string; tokenToLogin?: string }) => void;
  onNavigateToPasswordlessLogin: () => void;
  onNavigateToPasswordLogin: () => void;
  onNavigateToSignUp: () => void;
  onSuccessLogin: () => Promise<void>;
};

const LoginSignpost = ({
  onNavigateToCheckCode,
  onNavigateToPasswordlessLogin,
  onNavigateToPasswordLogin,
  onNavigateToSignUp,
  onSuccessLogin,
}: P) => {
  const { t } = useTranslation();

  const hasAnySocialLogin = Boolean(import.meta.env.VITE_APP_GOOGLE_CLIENT_ID);

  return (
    <>
      <Title level={1} marginBottom>
        {t('Log in')}
      </Title>
      <Section lineBottom={false} lineTop={false} paddingBottom paddingTop>
        <Row gutter={[0, 'ms']}>
          <Col span={24}>
            <Button
              block
              onClick={() => {
                onNavigateToPasswordLogin();
              }}
              size="large"
              type="primary"
            >
              {t('Use password')}
            </Button>
          </Col>
          <Col span={24}>
            <Button
              block
              onClick={() => {
                onNavigateToPasswordlessLogin();
              }}
              size="large"
            >
              {t('Send email link')}
            </Button>
          </Col>
        </Row>
      </Section>
      {hasAnySocialLogin ? (
        <>
          <Separator text="or" />
          <SocialButtons
            onNavigateToCheckCode={onNavigateToCheckCode}
            onNavigateToSignUp={onNavigateToSignUp}
            onSuccessLogin={onSuccessLogin}
          />
        </>
      ) : null}
    </>
  );
};

export default LoginSignpost;
